import request from '@apps-common/js-client/api/request';
import {
  API_BASE_URL,
  SH_LOGOUT_ENDPOINT,
  SH_PLANET_ACCOUNT_LINK_UNLINK_ENDPOINT,
  SH_TOKEN_ENDPOINT,
  PDA_ADMIN_V1_BASE_PATH as base,
} from '@account/config';
import {
  UNLINK_FAILED_ERROR,
  getLinkState,
  setLinkState,
} from '@account/utils/sentinel-hub';

export const getSentinelHubToken = (body, headers = {}) => {
  return request.post(SH_TOKEN_ENDPOINT, body, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...headers,
    },
  });
};
export const getSentinelHubUser = () => {
  return request.get(`${base}/my/link-sh/user`).then(res => res.data);
};

export const linkSentinelHubUser = (plToken, shToken) => {
  return request.post(
    `${API_BASE_URL}/${base}/my/link-sh`,
    {sh_access_token: shToken},
    {authToken: plToken}
  );
};

export const unlinkSentinelHubUserPdaAdmin = plToken => {
  return request.delete(`${API_BASE_URL}/${base}/my/link-sh`, {
    authToken: plToken,
  });
};

export const unlinkIdp = async (url, shToken) => {
  try {
    await request.delete(url, {authToken: shToken});
  } catch (error) {
    if (
      error.response &&
      error.response.status === 400 &&
      (error.response.data?.errorMessage ===
        'identityProviderNotFoundMessage' ||
        error.response.data?.errorMessage ===
          'federatedIdentityLinkNotActiveMessage')
    ) {
      // if this failed, it's because the user wasn't ever linked to the login provider in the Sentinel Hub IdP
      // we can no-op this
    } else {
      throw error;
    }
  }
};

export const logoutSentinelHubUser = async idToken => {
  // this request appears to fail with ERR_FAILED, but each time it does so, the logout goes through (confirmed by needing to reauthenticate to SH),
  // so I'm choosing to surpress the error here.
  // more investigation may reveal a better path, but this works.
  // (a logout is necessary so the user can re-link from an unauthenticated and clean slate if desired)
  try {
    await request.get(`${SH_LOGOUT_ENDPOINT}?id_token_hint=${idToken}`);
  } catch (error) {
    // no-op
  }
};

export const unlinkSentinelHubUser = async (id, plToken, shToken, idToken) => {
  try {
    await unlinkSentinelHubUserPdaAdmin(plToken);
    await unlinkIdp(SH_PLANET_ACCOUNT_LINK_UNLINK_ENDPOINT, shToken);
    await logoutSentinelHubUser(idToken);
    setLinkState(id, {
      ...getLinkState(id),
      error: undefined,
    });
  } catch (error) {
    setLinkState(id, {
      ...getLinkState(id),
      error: UNLINK_FAILED_ERROR,
    });
  }
};

export const startSentinelHubTrial = async () => {
  await request.post(`${base}/my/link-sh/start-trial`);
};

export const getSentinelHubUsage = () => {
  return request.get(`${base}/my/usage-sh`).then(res => res.data);
};

export const getSentinelHubCollections = () => {
  return request.get(`${base}/my/collections`).then(res => res.data);
};
